// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"2202":"895f7faac8a1e133","9651":"9f2fc892289dda5f"}[chunkId] + ".js";
};